import { USUARIO_LOGADO, USUARIO_NO_LOGADO } from "@/constants/get-my-products";
import { normalizeFusionInfoToStore } from "@/utils/normalizers/get-my-products";
const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";


export const initialState = {
  clientType: USUARIO_NO_LOGADO,
  principalProductType: null,
  getMyProductFetching: false,
  getMyProductLoaded: false,
  getMyProductFailure: false,
  categoryFusionInfo: null,
  fusionCategoryId: null,
  financing: false,
  hasAnyLinesMoreSixMonths: false,
  errorCategoryFusionInfo: false,
  totalPvp: null,
  monthlyPvp: null,
  creditLimitFetching: false,
  creditLimitFailure: false,
  creditLimitLoaded: false,
  includedR2RInfo: null,
  maxR2RReached: false,
  maxPackR2RReached: false,
  hiredR2RCount: 0,
  //Forced offer category
  foc: false,
  isUserNewModelR2R: false,
  userDiscountNewModelR2R: null,
};

export const types = {
  GET_MY_PRODUCTS_BEGINS: 'PRODUCTS/GET_MY_PRODUCTS_BEGINS',
  GET_MY_PRODUCTS_SUCCESS: 'PRODUCTS/GET_MY_PRODUCTS_SUCCESS',
  GET_MY_PRODUCT_ERROR: 'PRODUCTS/GET_MY_PRODUCT_ERROR',
  SET_KIND_CLIENT: 'PRODUCTS/SET_KIND_CLIENT',
  SET_CLIENT_TYPE: 'PRODUCTS/SET_CLIENT_TYPE',
  GET_CREDIT_LIMIT_BEGINS: 'PRODUCTS/GET_CREDIT_LIMIT_BEGINS',
  GET_CREDIT_LIMIT_SUCCESS: 'PRODUCTS/GET_CREDIT_LIMIT_SUCCESS',
  GET_CREDIT_LIMIT_FAILURE: 'PRODUCTS/GET_CREDIT_LIMIT_FAILURE',
  SET_CREDIT_LIMIT_LOADED: 'PRODUCTS/SET_CREDIT_LIMIT_LOADED',

};

const getMyProducts = (state = initialState, action) => {
  switch (action.type) {
    case HYDRATE: {
      let { getMyProducts } = action.payload;
      return {
        ...getMyProducts,
        ...state,
      }
    }

    case types.GET_MY_PRODUCTS_BEGINS:
      return {
        ...state,
        clientType: USUARIO_LOGADO,
        getMyProductFetching: true,
        getMyProductLoaded: false,
        getMyProductFailure: false,
      };

    case types.GET_MY_PRODUCTS_SUCCESS: {
      const { ppt, f, clt, halmsm } = action.data;
      return {
        ...state,
        clientType: clt,
        principalProductType: ppt,
        financing: f,
        hasAnyLinesMoreSixMonths: halmsm,
        getMyProductLoaded: true,
        getMyProductFetching: false,
        getMyProductFailure: false,
      };
    }

    case types.GET_MY_PRODUCT_ERROR: {
      return {
        ...state,
        getMyProductLoaded: true,
        getMyProductFetching: false,
        getMyProductFailure: true,
      }
    }

    case types.SET_CLIENT_TYPE: {
      const { clientType } = action.data;
      return {
        ...state,
        clientType,
      }
    }

    case types.SET_KIND_CLIENT: {
      const { clt, ppt, cfi, f, halmsm, ecfi, creditLimit, includedR2RInfo, profiles, maxR2RReached, maxPackR2RReached, foc, isUserNewModelR2R, userDiscountNewModelR2R } = action.payload;
      let totalPvp, monthlyPvp;
      try {
        if (creditLimit?.tpvp) {
          totalPvp = parseFloat(creditLimit?.tpvp);
        }
        if (creditLimit?.mpvp) {
          monthlyPvp = parseFloat(creditLimit?.mpvp);
        }
      } catch (error) {
        console.error("Error al parsear el limite de credito")
      }
      return {
        ...state,
        clientType: clt,
        foc,
        principalProductType: ppt,
        financing: f,
        categoryFusionInfo: normalizeFusionInfoToStore(cfi),
        fusionCategoryId: cfi,
        errorCategoryFusionInfo: ecfi,
        hasAnyLinesMoreSixMonths: halmsm,
        getMyProductFetching: false,
        getMyProductLoaded: true,
        getMyProductFailure: false,
        creditLimitLoaded: true,
        totalPvp,
        monthlyPvp,
        includedR2RInfo,
        profiles,
        maxR2RReached,
        maxPackR2RReached,
        isUserNewModelR2R,
        userDiscountNewModelR2R
      };
    }

    case types.GET_CREDIT_LIMIT_BEGINS: {
      return {
        ...state,
        creditLimitFetching: true,
        creditLimitFailure: false,
      };
    }

    case types.GET_CREDIT_LIMIT_SUCCESS: {
      const { getCreditLimitResponse, financing, clientType } = action.data
      const { tpvp, mpvp } = getCreditLimitResponse;
      return {
        ...state,
        totalPvp: tpvp,
        monthlyPvp: mpvp,
        financing,
        clientType,
        creditLimitFetching: false,
        creditLimitFailure: false,
        creditLimitLoaded: true,
      };
    }

    case types.GET_CREDIT_LIMIT_FAILURE: {
      return {
        ...state,
        totalPvp: null,
        monthlyPvp: null,
        creditLimitFetching: false,
        creditLimitFailure: action.error,
        creditLimitLoaded: true,
      };
    }

    case types.SET_CREDIT_LIMIT_LOADED: {
      return {
        ...state,
        creditLimitLoaded: true,
      }
    }

    default:
      return { ...state };
  }
};

export const actions = {
  getMyProducts: () => ({ type: types.GET_MY_PRODUCTS_BEGINS }),
  getMyProductsSuccess: (data) => ({ type: types.GET_MY_PRODUCTS_SUCCESS, data }),
  getMyProductsFailure: (error) => ({ type: types.GET_MY_PRODUCT_ERROR, error }),
  setKindClient: (data) => ({ type: types.SET_KIND_CLIENT, payload: data }),
  setClientType: (data) => ({ type: types.SET_CLIENT_TYPE, payload: data }),
  getCreditLimit: () => ({
    type: types.GET_CREDIT_LIMIT_BEGINS,
  }),
  getCreditLimitSuccess: (data) => ({
    type: types.GET_CREDIT_LIMIT_SUCCESS,
    data,
  }),
  getCreditLimitFailure: (error) => ({
    type: types.GET_CREDIT_LIMIT_FAILURE,
    error,
  }),
  setCreditLimitLoaded: () => ({
    type: types.SET_CREDIT_LIMIT_LOADED,
  }),
};

export default getMyProducts;
